import {
  API_KEY,
} from './constants';

export function getHeaders(fullXmlRequest) {
  const headers = {
    'X-DreamFactory-Api-Key': API_KEY,
  };

  if (fullXmlRequest === true) {
    headers['X-Requested-With'] = 'XMLHttpRequest';
  }

  const token = window.localStorage.getItem('session_token');
  if (token && token !== 'undefined') {
    headers['X-Dreamfactory-Session-Token'] = token;
  }

  return headers;
}



// WEBPACK FOOTER //
// ./src/api/Utils.js